<template>
  <div class="block" :class="getStatusCss(transaction.status)">
    <div class="header">
      <!-- <div
            class="title"
            style="float: right;color: red"
            v-if="session.type <= 1"
            @click.prevent="deleteTransaction(transaction._id)"
          >
            Удалить
          </div> -->
      <div class="title" style="float: right;">
        {{ getStatusText(transaction.status) }}
      </div>
      <div class="title">ID: {{ transaction._id }}</div>
    </div>

    <div class="content">
      <div class="block-left">
        <p><b>Дата:</b> {{ $dayjs(transaction.date).format("DD.MM.YYYY") }}</p>
        <p><b>Время:</b> {{ $dayjs(transaction.date).format("HH:mm:ss") }}</p>
        <p><b>IP:</b> {{ transaction.ip }}</p>
        <p>
          <b>Источник:</b>
          {{ (transaction.trans.source || "catbit").toUpperCase() }}
        </p>
        <p v-if="transaction.ledgerExchangeId">
          <b>Id в учете:</b>
          <a
            href="#"
            @click.prevent="
              $router.push({
                name: 'LedgerEdit',
                params: { id: transaction.ledgerExchangeId }
              })
            "
          >
            {{ transaction.ledgerExchangeId }}
          </a>
        </p>
        <p v-else-if="transaction.status === 2 || transaction.status === 106">
          <a
            href="#"
            @click.prevent="
              $router.push({
                name: 'LedgerAddByTransactionId',
                params: { transactionId: transaction._id }
              })
            "
          >
            Создать операцию в учете
          </a>
        </p>
        <h4>Покупаем:</h4>
        <hr />
        <p>
          <b>Валюта:</b>
          {{ transaction.give.valute ? transaction.give.valute.title : "" }}
        </p>
        <p>
          <b>Курс:</b> {{ transaction.give.valute.course }}
          {{ "RUB" }}
        </p>
        <p>
          <b>Комиссия:</b>
          {{ 100 - +transaction.give.valute.percentGive * 100 }}%
        </p>
        <div>
          <b>Кошелек:</b>
          {{
            transaction.give.wallet
              ? transaction.give.wallet.title
              : "Не известно"
          }}
        </div>
        <div v-if="transaction.give.wallet">
          <div
            v-for="(form, index) in transaction.give.wallet.forms"
            :key="index"
          >
            &nbsp;<b>{{ index + 1 }})</b>
            {{ form ? form.title : "Нет информации" }} -
            {{ form ? form.description : "Нет информации" }}

            <div class="wallet-form-additional-info">
              {{
                form
                  ? !form._id &&
                    form.title == "Кошелек" &&
                    form.description &&
                    form.description.length
                    ? "Кошелек Whitebit"
                    : ""
                  : ""
              }}
            </div>
          </div>
          <div>
            <div class="wallet-form-additional-info">
              {{ transaction.give.valute.invoiceCard ? "Инвойс Карта" : "" }}
              {{ transaction.give.valute.invoiceQw ? "Инвойс Qiwi" : "" }}
              {{
                transaction.give.valute.useSbercoreForDeposit
                  ? "Используется Sbercore"
                  : ""
              }}

              {{ transaction.give.valute.invoiceYou ? "Инвойс ЮMoney" : "" }}
              <div v-if="transaction.trans.paymentId">
                <div
                  v-if="
                    transaction.trans.sbercoreDepositResult &&
                      transaction.trans.sbercoreDepositResult.id
                  "
                >
                  <div>
                    Карта Sbercore:
                    {{ transaction.trans.sbercoreDepositResult.card_number }}
                  </div>
                  <div>
                    ФИО Sbercore:
                    {{ transaction.trans.sbercoreDepositResult.last_name }}
                    {{ transaction.trans.sbercoreDepositResult.first_name }}
                    {{ transaction.trans.sbercoreDepositResult.middle_name }}
                  </div>
                </div>
                <div>
                  {{ `ID: ${transaction.trans.paymentId}` }}
                </div>
                <div>
                  Поступление средств контролируется автоматически
                </div>
                <div v-if="transaction.trans.vanilaDepositStatus">
                  <div>
                    Ожидаемое кол-во:
                    {{ transaction.trans.vanilaDepositStatus.amount }}
                  </div>
                  <div>
                    Поступившее кол-во:
                    {{ transaction.trans.vanilaDepositStatus.payment_amount }}
                  </div>
                </div>
              </div>

              <div
                v-if="transaction.trans.sbercoreDepositError"
                class="wb-withdraw-error"
              >
                <div>
                  Произошла ошибка получения реквизитов Sbercore
                </div>
                <div
                  v-if="
                    transaction.trans.sbercoreDepositError.message !== undefined
                  "
                >
                  <div v-if="transaction.trans.sbercoreDepositError.message">
                    <div style="word-break: break-all;">
                      Сообщение:
                      {{ transaction.trans.sbercoreDepositError.message }}
                    </div>
                  </div>
                  <div v-if="transaction.trans.sbercoreDepositError.errors">
                    <div
                      v-for="error in Object.entries(
                        transaction.trans.sbercoreDepositError.errors
                      )"
                      style="word-break: break-all;"
                      :key="error[0]"
                    >
                      Ошибки: {{ error[0] }}: {{ error[1].join(" ") }}
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="
                  transaction.trans.wbDepositStatus &&
                    transaction.trans.wbDepositStatus.account
                "
              >
                <div>
                  Поступление средств на WB контролируется автоматически
                </div>
                <div v-if="transaction.trans.wbDepositStatus.account.address">
                  <b>Сгенерированный кошелек WB:</b>
                  {{ transaction.trans.wbDepositStatus.account.address }}
                </div>
                <div v-if="transaction.trans.wbDepositStatus.account.memo">
                  <b>MEMO WB:</b>
                  {{ transaction.trans.wbDepositStatus.account.memo }}
                </div>
                <div
                  v-if="
                    transaction.trans.wbDepositResult &&
                      transaction.trans.wbDepositResult.records &&
                      transaction.trans.wbDepositResult.records[0]
                  "
                >
                  <div>
                    Статус:
                    {{
                      getWBDepositStatus(
                        transaction.trans.wbDepositResult.records[0].status
                      )["text"]
                    }}
                  </div>
                  <div>
                    Сумма:
                    {{ transaction.trans.wbDepositResult.records[0].amount }}
                    {{ transaction.trans.wbDepositResult.records[0].ticker }}
                  </div>
                  <div
                    v-if="
                      transaction.trans.wbDepositResult.records[0]
                        .transactionHash
                    "
                  >
                    Хэш транзакции:
                    {{
                      transaction.trans.wbDepositResult.records[0]
                        .transactionHash
                    }}
                  </div>
                  <div
                    v-if="
                      transaction.trans.wbDepositResult.records[0].confirmations
                    "
                  >
                    Подтверждения сети:
                    {{
                      transaction.trans.wbDepositResult.records[0].confirmations
                        .actual
                    }}
                    из
                    {{
                      transaction.trans.wbDepositResult.records[0].confirmations
                        .required
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="transaction.trans.ccard">
            <div>
              Средства должны поступить на карту
              {{ transaction.trans.ccard }}
            </div>
          </div>
        </div>
        <br />
        <hr />
        <p><b>Формы:</b></p>
        <ul style="margin-left: 20px">
          <li v-for="form in transaction.give.forms" :key="form.key">
            {{ form ? form.title : "" }}: {{ form.value }}
          </li>
        </ul>
      </div>
      <div class="block-right">
        <h4>Продаем:</h4>
        <hr />
        <p>
          <b>Валюта:</b>
          {{ transaction.get.valute ? transaction.get.valute.title : "" }}
        </p>
        <p>
          <b>Курс:</b> {{ transaction.get.valute.course }}
          {{ "RUB" }}
        </p>
        <p>
          <b>Комиссия:</b>
          {{ +parseFloat(transaction.get.valute.percentGet) * 100 - 100 }}%
        </p>
        <p>
          <b>Кошелек:</b>
          {{
            transaction.get.wallet
              ? transaction.get.wallet.title
              : "Не известно"
          }}
        </p>

        <div
          v-if="transaction.trans.wbConvertStatus"
          class="wallet-form-additional-info"
        >
          <div>
            Произведена автоматическая конвертация на WB
          </div>
          <div style="word-break: break-all;">
            Куплено {{ transaction.trans.wbConvertStatus.amount }}
            {{ transaction.trans.wbConvertStatus.market.split("_")[0] }} за
            {{ transaction.trans.wbConvertStatus.dealMoney }}
            {{ transaction.trans.wbConvertStatus.market.split("_")[1] }} (плюс
            комиссия {{ transaction.trans.wbConvertStatus.dealFee }}
            {{ transaction.trans.wbConvertStatus.market.split("_")[1] }})
          </div>
          <div style="word-break: break-all;">
            ID ордера: {{ transaction.trans.wbConvertStatus.orderId }}
          </div>
        </div>
        <div v-if="transaction.trans.wbConvertError" class="wb-withdraw-error">
          <div>
            Произошла ошибка автоматической конвертации на WB!
          </div>
          <div v-if="transaction.trans.wbConvertError.code !== undefined">
            <div v-if="transaction.trans.wbConvertError.message">
              <div style="word-break: break-all;">
                Сообщение:
                {{ transaction.trans.wbConvertError.message }}
              </div>
            </div>
            <div v-if="transaction.trans.wbConvertError.errors">
              <div
                v-for="error in Object.entries(
                  transaction.trans.wbConvertError.errors
                )"
                style="word-break: break-all;"
                :key="error[0]"
              >
                Ошибки: {{ error[0] }}: {{ error[1].join(" ") }}
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="
            transaction.trans.wbWithdrawStatus &&
              transaction.trans.wbWithdrawStatus.uniqueId
          "
          class="wallet-form-additional-info"
        >
          <div>
            Отправка средств осуществляется автоматически
          </div>
          <div v-if="transaction.trans.wbWithdrawStatus.amount">
            <div style="word-break: break-all;">
              Сумма к отправке:
              {{ transaction.trans.wbWithdrawStatus.amount }}
            </div>
          </div>
          <div v-if="transaction.trans.wbWithdrawStatus.transactionHash">
            <div style="word-break: break-all;">
              Хэш транзакции:
              <a
                target="_blank"
                :href="getHashCheckUrl(transaction.trans.wbWithdrawStatus)"
              >
                {{ transaction.trans.wbWithdrawStatus.transactionHash }}
              </a>
            </div>
          </div>
        </div>
        <div v-if="transaction.trans.wbWithdrawError" class="wb-withdraw-error">
          <div>
            Произошла ошибка при создании автоматического вывода на WB!
          </div>
          <div v-if="transaction.trans.wbWithdrawError.code !== undefined">
            <div v-if="transaction.trans.wbWithdrawError.message">
              <div style="word-break: break-all;">
                Сообщение:
                {{ transaction.trans.wbWithdrawError.message }}
              </div>
            </div>
            <div v-if="transaction.trans.wbWithdrawError.errors">
              <div
                v-for="error in Object.entries(
                  transaction.trans.wbWithdrawError.errors
                )"
                style="word-break: break-all;"
                :key="error[0]"
              >
                Ошибки: {{ error[0] }}: {{ error[1].join(" ") }}
              </div>
            </div>
          </div>
        </div>
        <hr />
        <p><b>Формы:</b></p>
        <ul style="margin-left: 20px">
          <!-- <li>Количество: {{ (+transaction.give.forms[0].value * transaction.give.valute.course * transaction.give.valute.percentGive / transaction.get.valute.course) * transaction.get.valute.percentGet }}</li> -->
          <!-- <li>Количество: {{ (+transaction.give.forms[0].value * transaction.give.valute.course * transaction.give.valute.percentGive / transaction.get.valute.course) / transaction.get.valute.percentGet }}</li> -->
          <li v-for="form in transaction.get.forms" :key="form.key">
            {{ form ? form.title : "" }}: {{ form.value }}
          </li>
        </ul>
      </div>
      <hr />

      <div class="verification-image" v-if="+transaction.status === 6">
        <img :src="transaction.verificationImage" alt="" />
      </div>

      <div
        class="buttons"
        style="color: red"
        v-if="
          [3, 4].includes(+transaction.status) &&
            transaction.trans.wbWithdrawStatus
        "
      >
        При автоматической отправке средств произошел сбой! Необходимо проверить
        данную транзакцию вручную!
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { getHashCheckUrl } from "./helpers";
export default {
  name: "OrderTransaction",
  props: {
    transaction: {
      type: Object
    }
  },
  methods: {
    getHashCheckUrl,

    getStatusText(status) {
      switch (+status) {
        case 0:
          return "В ожидании средств";
        case 1:
          return "В обработке";
        case 2:
          return "Подтверждено";
        case 3:
          return "Отклонено";
        case 4:
          return "Отменено";
        case 5:
          return "В ожидании фото для верификации";
        case 6:
          return "Верификация";
        case 106:
          return "Возобновлен";
      }
    },

    getStatusCss(status) {
      switch (+status) {
        case 0:
        case 1:
          return { orange: true };
        case 2:
        case 106:
          return { green: true };
        case 3:
        case 4:
          return { red: true };
      }
    },
    getWBDepositStatus(status) {
      const statuses = [
        { id: 3, originalText: "Successfull", text: "Успешно" },
        { id: 7, originalText: "Successfull", text: "Успешно" },
        { id: 4, originalText: "Canceled", text: "Отменено" },
        { id: 9, originalText: "Canceled", text: "Отменено" },
        {
          id: 5,
          originalText: "Unconfirmed by user",
          text: "Неподтверждено пользователем"
        },
        { id: 22, originalText: "Uncredited", text: "Неоплачено" },
        { id: 15, originalText: "Pending", text: "В ожидании" }
      ];
      const unknownStatus = {
        id: 0,
        originalText: "Unknown",
        text: "Неизвестно"
      };
      return statuses.find(s => s.id === status) || unknownStatus;
    }
  }
};
</script>

<style scoped>
.green {
  border-left: 5px solid green;
}
.orange {
  border-left: 5px solid orange;
}
.red {
  border-left: 5px solid red;
}

.content {
  overflow: hidden;
}

.block-left,
.block-right {
  float: left;
  padding: 0 5px 10px 5px;
  width: calc(50% - 11px);
}

.block-left {
  border-right: 1px solid #d9d9d9;
}

.buttons {
  margin-top: 10px;
  display: inline-block;
  width: 100%;
}

.buttons > button {
  width: 49%;
  display: inline-block;
  cursor: pointer;
}

.buttons > button.ok {
  background-color: green;
  color: #ffffff;
}

.buttons > button.cancel {
  background-color: red;
  color: #ffffff;
}

.verification-image {
  max-width: 800px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  border: 1px solid #aaa;
}
.verification-image img {
  display: block;
  width: 100%;
  height: auto;
}

.wallet-form-additional-info {
  font-size: 15px;
  color: blue;
  font-weight: 600;
  padding-top: 5px;
}
.wb-withdraw-error {
  font-size: 15px;
  color: red;
  font-weight: 600;
  padding-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/OrderTransaction.vue